import styled from "styled-components"

const StyledPickerContainer = styled.div`
  display: flex;
  overflow-y: auto;
  width: 90%%;
`

export default StyledPickerContainer
